import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getSummaryByUserId(userId) {
    return axiosInstance
        .get(`${BACKEND_ENDPOINT}/summary/getSummaryByUserId`, {
            params: {userId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
